__turbopack_context__.v({
  "btnContainer": "UqUH1G_btnContainer",
  "columnLeft": "UqUH1G_columnLeft",
  "columnRight": "UqUH1G_columnRight",
  "innerWrap": "UqUH1G_innerWrap",
  "labelSeparator": "UqUH1G_labelSeparator",
  "left": "UqUH1G_left",
  "no-image": "UqUH1G_no-image",
  "overlay": "UqUH1G_overlay",
  "videoControls": "UqUH1G_videoControls",
  "welcome": "UqUH1G_welcome",
});
